import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { LastRechtRootEntryVm, StandardrechtViewmodelService } from '../../../core/services/standardrecht-viewmodel.service';
import { ListLoaderInfiniteBuilder } from '../../../shared/components/list-loader/list-loader-infinite';
import { AppConfigService } from '../../../core/services/app-config.service';
import { TimepointService } from '../../../core/services/timepoint.service';
import { GbgrundstueckService } from '../../../core/gb-api';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { map, tap } from 'rxjs/operators';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { StandardrechtTableComponent } from '../../../shared/widgets/standardrecht-table/standardrecht-table.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundstueck-grundlasten-rubrik',
  templateUrl: './grundstueck-grundlasten-rubrik.component.html',
  styleUrls: ['./grundstueck-grundlasten-rubrik.component.scss'],
  imports: [RubrikComponent, StandardrechtTableComponent, TranslatePipe]
})
export class GrundstueckGrundlastenRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  loader: ListLoader<LastRechtRootEntryVm>;
  ersterfassungUebergeben: boolean;

  private readonly CHUNK_SIZE = 5;
  private readonly PAGE_SIZE = 5;
  private readonly CURRENT_PAGE = 1;

  constructor(
    private standardrechtViewmodelService: StandardrechtViewmodelService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected loadData() {
    this.loader = this.createGrundlastLoader();
  }

  private createGrundlastLoader(): ListLoader<LastRechtRootEntryVm> {
    const observable = (offset: number, limit: number) => {
      return this.standardrechtViewmodelService.loadSichtByGrundstueckId(this.gsId, 'GRUNDLAST', offset, limit, this.subscriptions).pipe(
        tap((res) => (this.ersterfassungUebergeben = res.ersterfassungUebergeben)),
        map((res) => res.entries)
      );
    };
    const loader = ListLoaderInfiniteBuilder.builder<LastRechtRootEntryVm>()
      .setLookupItemFunc(observable)
      .setChunkSize(this.CHUNK_SIZE)
      .setPageSize(this.PAGE_SIZE)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPublishItemsWhenAllLoaded(true)
      .build();
    this.addLoader(loader);
    return loader;
  }
}
